import client from "../api/client";
export const getList = () => {
  return client('/api/timezones').then(({ data }) => data.data);
};

export function useTimezoneService () {
  return {
    getList,
  };
}
